<template>
  <div>
    <div v-if="sourceUrlDomain">
      <a
        :href="sourceUrlDomain"
        target="_blank"
        >{{ params.data.sourceUrl }}<i class="fas fa-arrow-up-right-from-square"></i
      ></a>
    </div>
    <div v-else>
      <span>-</span>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    sourceUrlDomain() {
      if (this.params.data.sourceUrl) {
        let url = this.params.data.sourceUrl
          .replace("https://", "")
          .replace("http://", "");
        return "https://" + url;
      }
      return "";
    },
  },
};
</script>

<style lang="scss" scoped>
.fas {
  margin-left: 0.5rem;
}
</style>
